// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4223) return "static/chunks/commons-dc95a5e298eff68a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6492 ? "lib.framer-motion" : chunkId) + "." + {"1474":"b4adaa9d0592ae37","1857":"b02ee0f9805949c2","2640":"2871f9610bfce6c2","2833":"b88625f817e00a17","6492":"17216f7e24aa1e91","7183":"61b814b215a7b181","7476":"5d2efee8253abd91","8323":"7f95189571383945","8887":"07bc3c3e087f086c"}[chunkId] + ".js";
};